import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Layout from './components/Layout';
import DashboardPage from './pages/workspace/DashboardPage';
import Contacts from './pages/workspace/Contacts';
import SendBulkSms from './pages/workspace/SendBulkSms';
import SendSingleSms from './pages/workspace/SendSingleSms';
import Templates from './pages/workspace/Templates';
import Campaigns from './pages/workspace/Campaigns';
import Packages from './pages/workspace/Packages';
import Billing from './pages/workspace/Billing';
import Reports from './pages/workspace/Reports';
import Profile from './pages/workspace/Profile';
import Settings from './pages/workspace/Settings';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="send-bulk-sms" element={<SendBulkSms />} />
          <Route path="send-single-sms" element={<SendSingleSms />} />
          <Route path="templates" element={<Templates />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="packages" element={<Packages />} />
          <Route path="billing" element={<Billing />} />
          <Route path="reports" element={<Reports />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
